/**
 * 自定义查询 - 路由自注册与打开入口
 *
 * 宿主无需在项目里手写路由：首次打开时会把 3 个页面路由动态注入到宿主的 router，
 * 之后通过 window.open 打开新页面（组件所有跳转均为新开页面）。任何地方只要拿到 router 实例即可调用 openCustomQuery。
 */
import { ROUTE_NAMES, ROUTE_PATHS, openRouteInNewTab, setStore } from './runtime';

var routesAdded = false;

function buildRoutes() {
  return [{ path: ROUTE_PATHS.config, name: ROUTE_NAMES.config, meta: { title: '自定义查询', hideInMenu: true }, component: function component() {
      return import( /* webpackChunkName: "custom-query" */'./pages/config-page.vue');
    } }, { path: ROUTE_PATHS.history, name: ROUTE_NAMES.history, meta: { title: '历史查询模版', hideInMenu: true }, component: function component() {
      return import( /* webpackChunkName: "custom-query" */'./pages/history-page.vue');
    } }, { path: ROUTE_PATHS.result, name: ROUTE_NAMES.result, meta: { title: '查询结果', hideInMenu: true }, component: function component() {
      return import( /* webpackChunkName: "custom-query" */'./pages/result-page.vue');
    } }];
}

/**
 * 确保路由已注册到宿主 router（幂等）
 * @param {VueRouter} router
 */
export function ensureCustomQueryRoutes(router) {
  if (!router) {
    console.warn('[custom-query] 缺少 router 实例，无法注册路由');
    return;
  }
  // 已存在则跳过（兼容热更新/多次调用）
  var existed = typeof router.getRoutes === 'function' && router.getRoutes().some(function (r) {
    return r.name === ROUTE_NAMES.config;
  });
  if (routesAdded || existed) {
    return;
  }
  var routes = buildRoutes();
  if (typeof router.addRoute === 'function') {
    routes.forEach(function (r) {
      return router.addRoute(r);
    });
  } else if (typeof router.addRoutes === 'function') {
    // 兼容 vue-router < 3.5
    router.addRoutes(routes);
  }
  routesAdded = true;
}

/**
 * 打开自定义查询（配置页，新页面）
 * @param {VueRouter} router 宿主 router 实例（组件内 this.$router）
 * @param {Object} options { mark, store, appId }
 */
export function openCustomQuery(router) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // 注入宿主 store，供 real-api 内部 dispatch 使用（不能静态 import '@/store'）
  if (options.store) {
    setStore(options.store);
  }
  ensureCustomQueryRoutes(router);
  openRouteInNewTab(router, { name: ROUTE_NAMES.config, query: { mark: options.mark || '', appId: options.appId || '' } });
}


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/custom-query/routes.js
// module id = 19
// module chunks = 0